import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Flex, Typography } from '@robinpowered/ui-kit';
import OfficeSpace from '../../../images/OfficeSpace.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faVideo,
  faUsers,
  faPhone,
} from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { useTranslation } from 'react-i18next';

interface SpaceItemProps {
  name: string;
}

export const SpaceItem: FC<SpaceItemProps> = ({ name }) => {
  const { t } = useTranslation('downloadMobileAppModal');
  return (
    <>
      <Flex style={{ marginBottom: '5px', marginTop: '6px' }}>
        <Flex vertical>
          <Typography.Paragraph
            style={{
              marginBottom: '2px',
              fontWeight: '400',
              textAlign: 'left',
            }}
          >
            {name}
          </Typography.Paragraph>
          <Flex gap={2} style={{ width: '155px' }}>
            <FontAwesomeIcon
              icon={faVideo}
              width={13}
              height={13}
              color={'#706E6E'}
            />
            <FontAwesomeIcon
              icon={faUsers}
              width={13}
              height={13}
              color={'#706E6E'}
            />
            <FontAwesomeIcon
              icon={faPhone}
              width={13}
              height={13}
              color={'#706E6E'}
            />
            <Label>{t('space_item_label')}</Label>
          </Flex>
        </Flex>
        <SpaceImage src={OfficeSpace} />
      </Flex>
      <BookSpaceButton>{t('space_item_button')}</BookSpaceButton>
    </>
  );
};

const SpaceImage = styled.img`
  width: 45px;
`;

const Label = styled.div`
  font-size: 8px;
  color: #706e6e;
  background-color: #f8f6f4;
  border-radius: 2px;
  padding: 1px 2px 1px 4px;
  margin-left: 2px;
`;

const BookSpaceButton = styled.div`
  border: 1px solid #cbc9c9;
  border-radius: 4px;
  padding: 5px 8px 5px;
  width: 40px;
  font-size: 8px;
  font-weight: 500;
`;
